import React, { useEffect, useState} from 'react'
import styles from './Result.module.css'
import birds from '../../data.json'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'


import { addNewResponse } from '../../actions/responses'

const Result = ( { options }) => {

    const dispatch = useDispatch()
    const location = useLocation()
   
    //Retrieve user details from local storage
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))
    console.log(user)

    useEffect(()=> {

        setUser(JSON.parse(localStorage.getItem('profile')))
    }, [location]) 





    const filtered = birds.filter((bird) => {
        return(bird.Size === options.size &&
            options.mainColors.some( col => bird.mainColors.includes(col)) &&
            bird.headColor.includes(options.headColor) &&
            bird.upperColor.includes(options.upperColor) && 
            bird.bellyColor.includes(options.bellyColor)
            ) ||
        
            (options.mainColors.some( col => bird.mainColors.includes(col)) &&
            bird.headColor.includes(options.headColor) &&
            bird.upperColor.includes(options.upperColor) && 
            bird.bellyColor.includes(options.bellyColor)   
            )   
        }
    )

    return (
        <div className={styles.grid}>
          {filtered.map((bird) => {
              return (
                <div key={bird.commonName} className={styles.birdsConatiner}>
                    <img src={bird.imageUrl} alt={bird.commonName}/>
                    <h5>{bird.commonName}</h5>
                    <button 
                        onClick={
                            () => {
                                dispatch(addNewResponse({
                                    ...options, user: user.result.name,
                                commonName: bird.commonName, 
                                scientificName: bird.scientificName,
                                imageUrl: bird.imageUrl
                            }))
                                alert(`${bird.commonName} has been added to your checklist`)
                              }
                        }
                    >This is it
                    </button>
                </div>
              )
              
          })}
         
          {filtered.length === 0 && options.size !== "" ? (<div>We can't identify this species</div>) : ""}
        </div>
    )
}

export default Result
